import {generatePseudoSelect} from './UI.js';

let updateFilterTimeout;
let $filterWrap = $('.js-news-filter');
let $itemsWrap = $('.js-news-wrapper');
let $filterForm = $('.js-news-filter-form');
let $prelaoder = $('.js-preloader');
//let $tagFilterResetBtn = $('.js-tag-filter-reset-btn');

/*let $filterTagTitle = $('.js-filter-tag-title');
let $filterTagWrapper = $('.js-filter-tag-wrapper');
let $tagsClose = $('.js-tags-close');
let $tagFilterResultBtn = $('.js-tag-filter-result-btn');*/

/* пагинация на странице новостей */
if (App.H.hasClass('page-news')) {
    App.H.on('click', '.js-pagination-item', function (e) {
        e.preventDefault();

        let currValue = $(this).attr('href');

        App.H.find(`.js-pagination-select option[value="${currValue}"]`).prop('selected', true).attr('selected', 'selected').trigger('change');
    });


    App.H.on('change', '.js-pagination-select', function () {
        $('.js-page').val($(this).val());

        getFilter(true);
    });


    //$filterTagTitle.on('click', function (e) {
    App.H.on('click', '.js-filter-tag-title', function (e) {
        $('.js-filter-tag-wrapper').toggleClass('_open');

        e.preventDefault();
    });

    //$tagsClose.on('click', function (e) {
    App.H.on('click', '.js-tags-close', function (e) {
        $('.js-filter-tag-wrapper').removeClass('_open');

        e.preventDefault();
    });

    App.H.on('click', '.js-tag-filter-reset-btn', function (e) {
        $('.js-filter-tag-wrapper').find('input[type="checkbox"]').prop('checked', false);

        getFilter();

        e.preventDefault();
    });

    //$('.js-tag-filter-result-btn')
    //$tagFilterResultBtn.on('click', function (e) {
    App.H.on('click', '.js-tag-filter-result-btn', function (e) {
        getFilter();

        e.preventDefault();
    });
}

export function selectFilters() {
    if (!App.H.hasClass('page-news')) { return false; }

    getFilter();
}

function checkHiddenFilters() {
    let $hiddenSelect = $('.js-news-filter').find('select[data-dependence]');

    if ($hiddenSelect.length) {
        let _hiddenBlock = $hiddenSelect.data('hidden');

        if (typeof _hiddenBlock != "undefined" && $hiddenSelect.val() === 'all') {
            $(`.js-pseudo-select-select[name="${_hiddenBlock}"]`).closest('.js-filter-item').addClass('_hidden');
        } else {
            $(`.js-pseudo-select-select[name="${_hiddenBlock}"]`).closest('.js-filter-item').removeClass('_hidden');
        }
    }
}

/* Собираем данные фильтра и делаем запрос на сервер */
function getFilter(scrollTop) {
    clearTimeout(updateFilterTimeout);

    $prelaoder.addClass('_active');
    $itemsWrap.addClass('_hidden');
    $filterWrap.addClass('_hidden');

    if (!scrollTop) {
        App.H.find('.js-page-value').val(1);
    }

    const formData = App.H.find('.js-news-filter-form').serialize();

    $.ajax({
        url: $filterForm.attr('action'),
        data: formData,
        cache: false,
        success: (response) => {
            updateFilter(response);
            checkHiddenFilters();

            /* Скроллим к началу товаров, если пагинация */
            if (scrollTop) {
                $('html, body').animate({
                    scrollTop: $itemsWrap.offset().top - 140
                }, 800);
            }

            if (window.history) {
                window.history.replaceState({}, '', '?' + formData);
            }
        },
        error: () => {
            clearFilterPreloader();

            console.log('Ошибка получения данных фильтра');
        }
    });
}

/* Готовим прелоадер к следующему испольхованию */
export function clearFilterPreloader() {
    setTimeout(() => {
        $prelaoder.removeClass('_active');
        $itemsWrap.removeClass('_hidden');
        $filterWrap.removeClass('_hidden');
    }, 500);
}

/* Обновляем фильтры и новости */
function updateFilter(html) {
    const $newFilterWrap = $(html).find('.js-news-filter');
    const $newItems = $(html).find('.js-news-wrapper');
    const $newPaging = $(html).find('.js-paging');
    const $newDesktopPaging = $(html).find('.js-desktop-paging');

    $filterWrap.html($newFilterWrap.html());
    $itemsWrap.html($newItems.html());

    if ($newPaging) {
        $('.js-paging').html($newPaging.html());
    }

    if ($newDesktopPaging) {
        $('.js-desktop-paging').html($newDesktopPaging.html());
    }

    generatePseudoSelect($filterWrap.find('.js-pseudo-select'));
    clearFilterPreloader();
}


// WEBPACK FOOTER //
// ./_src/js/modules/PageNews.js